module.exports = __webpack_public_path__ + "img/qr-code-apple.1ea5bfcc.png";